import { render, staticRenderFns } from "./ListCollectionCreator.vue?vue&type=template&id=a35322ea&scoped=true"
import script from "./ListCollectionCreator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListCollectionCreator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListCollectionCreator.vue?vue&type=style&index=0&id=a35322ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35322ea",
  null
  
)

export default component.exports